import { TextLayer } from "@/stellar-globe-components";
import Vue, { CreateElement } from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

const fieldInfo = [
  { text: "SXDS", position: [0.8235226223144847, 0.5599780192825095, -0.0907474983496084] },
  { text: "AEGIS", position: [-0.494942512287926, -0.3469946584393124, 0.7966345564590461] },
  { text: "HECTOMAP", position: [-0.2929384798414137, -0.6779091356520174, 0.6742597799273929] },
  { text: "GAMA15H", position: [-0.7903260692668805, -0.6125489261184914, -0.012981423197972988] },
  { text: "GAMA09H", position: [-0.7047582686956577, 0.7093287427962116, 0.012981423197973217] },
  { text: "COSMOS", position: [-0.8675226003731931, 0.4958715188284965, 0.03893551921386405] },
  { text: "WIDE01H", position: [0.94459370376398366, 0.32801833373878997, 0.012112288828602569] },
  { text: "WIDE12H", position: [-0.9998321746731913, 0.012926915333220804, -0.012981423197972988] },
  { text: "ELAIS-N1", position: [-0.2513068068214377, -0.5030149505987969, 0.8269346094579079] },
  { text: "VVDS", position: [0.9439561820094772, -0.32981541670735437, 0.012981423197973217] },
  { text: "DEEP2-3", position: [0.9915709439195408, -0.1289129389404573, -0.012981423197972988] },
]

@Component
export default class FieldName extends Vue {
  @Prop({ default: 1 })
  alpha!: number

  render(h: CreateElement) {
    return h(TextLayer, {
      props: {
        text: fieldInfo,
        alpha: this.alpha,
      },
    })
  }
}
